import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { SECONDARY_API_CLIENT } from 'services/API';
import { When } from 'UI/components/atoms';
import { ProfileAlert } from 'UI/components/molecules/ProfileAlert';
import { Endpoints } from 'UI/constants/endpoints';
import { UIStatus } from 'UI/constants/status';

/**
 * Payment warning of a company, under ProfileAccountableBar in the Company subheader.
 * Copied from V1 CompanyProfile/components/CompanyPaymentStatusAlert, which is deleted with V1;
 * same props and same fetch.
 * @param {Object} props
 * @param {number|string} props.companyId Company id
 * @param {boolean} [props.isLoading] The profile is loading: the alert waits for it
 */
export const CompanyPaymentStatusAlert = ({ companyId, isLoading = false }) => {
  const { state: paymentStatusState } = useFetchWithStatusV2({
    endpoint: companyId ? Endpoints.CompanyPaymentStatus.replace(':id', String(companyId)) : null,
    apiInstance: SECONDARY_API_CLIENT
  });

  const isPaymentStatusLoaded = paymentStatusState?.status === UIStatus.Success;
  const paymentStatus = paymentStatusState?.results;

  return (
    <When condition={!isLoading && isPaymentStatusLoaded && paymentStatus?.hasWarning}>
      <ProfileAlert
        primaryText={paymentStatus?.warning?.content}
        severity="error"
        title={paymentStatus?.warning?.title}
      />
    </When>
  );
};
